import { defineComponent, inject, provide } from 'vue';
import { IIncentiveV2Store } from '@/domain/dto/store.incentive-v2.interfaces';
import Captcha from '@/presentation/components/Form/Input/Captcha/Captcha.vue';
import NameInput from '../../Common/NameInput/NameInput.vue';
import EmailInput from '../../Common/EmailInput.vue';
import PasswordInput from '../../Common/Password/PasswordInput/PasswordInput.vue';
import SubmitButton from '../../Common/SubmitButton/SubmitButton.vue';
import EmailRegistration from './EmailRegistration.class';
import { setupComponent } from '@studyportals/vue-platform';
import SocialIncentiveButtons from '../../SocialIncentiveButtons/SocialIncentiveButtons.vue';
import PrivacyStatement from '../../privacystatement/PrivacyStatement.vue';
import RedirectToLogin from '../../Common/RedirectToLogin/RedirectToLogin.vue';



export default defineComponent({
	components: {
		Captcha,
		NameInput,
		EmailInput,
		PasswordInput,
		SocialIncentiveButtons,
		SubmitButton,
		PrivacyStatement,
		RedirectToLogin
	},
	setup: () => {
		const store = inject<IIncentiveV2Store>('incentiveV2Store');
		if (!store) throw new Error('incentiveV2Store was not provided');
		/* gives the Captcha widget this instance's isolated token handle, see Captcha.ts */
		provide('captchaInstance', store.captcha);
		const component = new EmailRegistration(store);
		return setupComponent(component);
	},
});
